export default __webpack_public_path__ + "static/media/discounts-vip-image.8a11c4ce.svg";